"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultConfiguration = exports.sanitizeFields = exports.dataFive9Chat = void 0;
var constants_1 = require("./constants");
var utils_1 = require("../utils");
var survey_1 = require("./survey");
function dataFive9Chat() {
    var keysLocalStorage = Object.keys(window.localStorage);
    var f9KeyLocalStorage = keysLocalStorage.findIndex(function (value) {
        return value.match(/f9-chat*/);
    });
    var f9ChatLocalStorage = window.localStorage.getItem(keysLocalStorage[f9KeyLocalStorage]);
    if (f9ChatLocalStorage)
        f9ChatLocalStorage = JSON.parse(f9ChatLocalStorage);
    return f9ChatLocalStorage;
}
exports.dataFive9Chat = dataFive9Chat;
function sanitizeFields(configurations) {
    Object.keys(configurations).map(function (key) {
        if (key === constants_1.FIELDS_FIVE9_PROPERTY) {
            Object.keys(configurations[key]).map(function (field) {
                Object.keys(configurations[key][field]).map(function (property) {
                    if (property == constants_1.REMOVE_FIVE9_DEFAULT_PROPERTY &&
                        configurations[key][field][property]) {
                        delete configurations[key][field];
                    }
                });
            });
        }
    });
    return configurations;
}
exports.sanitizeFields = sanitizeFields;
function getDefaultConfiguration() {
    var configurations = {
        survey: {
            urlSendSurvey: "https://wapdsurveysiigoapi.azurewebsites.net/api/",
        },
    };
    (0, survey_1.setURLSendSurvey)(configurations.survey.urlSendSurvey);
    return (0, utils_1.merge)(constants_1.DEFAULT_FIVE9_CONFIGURATION, configurations);
}
exports.getDefaultConfiguration = getDefaultConfiguration;
//# sourceMappingURL=utils.js.map